import { Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import foodImg from "../../assets/mdi_food.png";
import scooterImg from "../../assets/scooter.png";
import dineIn from "../../assets/dinein.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LanguageMenuItem from "../../components/SelectComponent/LanguageMenuItem";
import {
  setLanguageData,
  updateDefaultLanguage,
  updateDeliveryType,
} from "../../store/slice/Webshop.slice";
import { RibbonTag } from "../WebshopWidget/DeliveryTypeScreen";

const DeliveryTypeScreen = () => {
  const [startHere, setStartHere] = useState(true);
  const dispatch = useDispatch();
  const [deliveryType, setDelvieryType] = useState("");
  const navigate = useNavigate();
  const { languageData, defaultLanguage,shopType,webshopSettings,languageWords,langID,webshopOpeningHours} = useSelector(
    (store) => store?.Webshop
  );
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <LanguageMenuItem
          languageData={languageData}
          updateLanguageData={setLanguageData}
          defaultLanguage={defaultLanguage}
          updateDefaultLanguage={updateDefaultLanguage}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Main Content */}
        <Box>
          {/* Header Section */}
           <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              px: 2,
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                color: "#F37120",
                fontSize: { xs: "24px", md: "40px" },
                fontWeight: 600,
                mb: 1,
              }}
            >
              {webshopSettings?.webshopWidgetSetupLanguages?.find((item)=>item?.fieldname == 'PickupOrDeliveryScreenHeading' && item?.idlanguage == langID)?.data}
            </Typography>
            <Typography
              sx={{
                width: { md: 650, xs: "100%" },
                textAlign: "center",
                fontSize: "16px",
                color: "#969BA0",
                lineHeight: "1.5rem",
              }}
            >
               {webshopSettings?.webshopWidgetSetupLanguages?.find((item)=>item?.fieldname == 'PickupOrDeliveryScreenInfo' && item?.idlanguage == langID)?.data}
            </Typography>
          </Box>

          {/* kiosk start type true */}
          {startHere  && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: 2,
                width: "100%", // Full width to center horizontally
              }}
            >
              <Box
                  sx={{
                    width: { xs: "80%", sm: "240px" },
                    height: "280px",
                    backgroundColor:
                      deliveryType === "DineIn"  ? "#F37120" : "#ffffff",
                    borderRadius: "20px",
                    boxShadow:
                      deliveryType === "DineIn" 
                        ? "0 6px 18px rgba(243, 113, 32, 0.4)"
                        : "0 4px 12px rgba(0,0,0,0.1)",
                    transition: "all 0.3s ease",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    position: "relative",
                    "&:hover": {
                      transform: "translateY(-6px)",
                      boxShadow:
                        "0 10px 25px rgba(243, 113, 32, 0.35)",
                    },
                  }}
                onClick={() => {
                  setStartHere(false);
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#FFF8F6",
                    width: "90%",
                    height: "80%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "18px",
                  }}
                >
                  <img
                    style={{ width: "150px", height: "150px" }}
                    src={foodImg}
                    alt="food-img"
                  />
                </Box>
                <Typography
                  sx={{
                    color: !startHere ? "#fff" : "#000",
                    fontSize: "20px",
                    fontWeight: 600,
                    mt: 2,
                  }}
                >
                  {languageWords?.startHere}
                </Typography>
              </Box>
            </Box>
          )}

          {/* kiosk choose type */}
          {!startHere  && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                flexWrap: "wrap",
                gap: { xs: "1.5rem", md: "3rem" },
                width: "100%",
                mt: 7,
                pb: 6, // Add padding to avoid overlap with footer
              }}
            >
              {/* Dine In */}
              {webshopSettings?.hasDineIn && webshopSettings?.showDineInKiosk &&
               <Box
               sx={{
                width: { xs: "80%", sm: "240px" },
                height: "280px",
                backgroundColor:
                  deliveryType === "DineIn"  ? "#F37120" : "#ffffff",
                borderRadius: "20px",
                boxShadow:
                  deliveryType === "DineIn" 
                    ? "0 6px 18px rgba(243, 113, 32, 0.4)"
                    : "0 4px 12px rgba(0,0,0,0.1)",
                transition: "all 0.3s ease",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                position: "relative",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow:
                    "0 10px 25px rgba(243, 113, 32, 0.35)",
                },
              }}
                onClick={() => {
                  dispatch(updateDeliveryType("DineIn"));
                  navigate(`/kisoMenuItem`);
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#FFF8F6",
                    width: "90%",
                    height: "80%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "18px",
                    opacity:!webshopOpeningHours?.value?.data?.companyOpen ? 0.25 : 1
                  }}
                >
                  <img
                    style={{ width: "150px", height: "150px" }}
                    src={dineIn}
                    alt="dine-img"
                  />
                </Box>
                <Typography
                  sx={{
                    color: deliveryType == "DineIn" ? "#fff" : "#000",
                    fontSize: "20px",
                    fontWeight: 600,
                    mt: 2,
                  }}
                >
                  {languageWords?.DineIn}
                </Typography>
                {!webshopOpeningHours?.value?.data?.companyOpen && <RibbonTag  data={"we are closed"}/>}
              </Box>}

              {/* pick up*/}
              {webshopSettings?.
hasPickup && webshopSettings?.showPickupKiosk &&
<Box
                    sx={{
                      width: { xs: "80%", sm: "240px" },
                      height: "280px",
                      backgroundColor:
                        deliveryType === "DineIn"  ? "#F37120" : "#ffffff",
                      borderRadius: "20px",
                      boxShadow:
                        deliveryType === "DineIn" 
                          ? "0 6px 18px rgba(243, 113, 32, 0.4)"
                          : "0 4px 12px rgba(0,0,0,0.1)",
                      transition: "all 0.3s ease",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      position: "relative",
                      "&:hover": {
                        transform: "translateY(-6px)",
                        boxShadow:
                          "0 10px 25px rgba(243, 113, 32, 0.35)",
                      },
                    }}
                onClick={() => {
                  dispatch(updateDeliveryType("pickup"));
                  navigate(`/kisoMenuItem`);
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#FFF8F6",
                    width: "90%",
                    height: "80%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "18px",
                    opacity:!webshopOpeningHours?.value?.data?.companyOpen ? 0.25 : 1
                  }}
                >
                  <img
                    style={{ width: "150px", height: "150px" }}
                    src={foodImg}
                    alt="pickup-img"
                  />
                </Box>
                <Typography
                  sx={{
                    color: deliveryType == "pickup" ? "#fff" : "#000",
                    fontSize: "20px",
                    fontWeight: 600,
                    mt: 2,
                  }}
                >
                 {languageWords?.Pickup}
                </Typography>
                {!webshopOpeningHours?.value?.data?.companyOpen && <RibbonTag  data={"we are closed"}/>}
              </Box>}
               {/*Delivery */}
              {webshopSettings?.hasDelivery && webshopSettings?.showDeliveryKiosk &&  webshopOpeningHours?.value?.data?.delivery && <Box
                   sx={{
                    width: { xs: "80%", sm: "240px" },
                    height: "280px",
                    backgroundColor:
                      deliveryType === "DineIn"  ? "#F37120" : "#ffffff",
                    borderRadius: "20px",
                    boxShadow:
                      deliveryType === "DineIn" 
                        ? "0 6px 18px rgba(243, 113, 32, 0.4)"
                        : "0 4px 12px rgba(0,0,0,0.1)",
                    transition: "all 0.3s ease",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    position: "relative",
                    "&:hover": {
                      transform: "translateY(-6px)",
                      boxShadow:
                        "0 10px 25px rgba(243, 113, 32, 0.35)",
                    },
                  }}
                onClick={() => {
                  dispatch(updateDeliveryType("delivery"));
                  navigate(`/kisoMenuItem`);
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#FFF8F6",
                    width: "90%",
                    height: "80%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "18px",
                  }}
                >
                    <img
                    style={{ width: "150px", height: "150px" }}
                    src={scooterImg}
                    alt="scooter-img"
                  />
                </Box>
                <Typography
                  sx={{
                    color: deliveryType == "delivery" ? "#fff" : "#000",
                    fontSize: "20px",
                    fontWeight: 600,
                    mt: 2,
                  }}
                >
                  {languageWords?.Delivery}
                </Typography>
              </Box>}

              
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default DeliveryTypeScreen;
